import React, { Component } from 'react';
import { Row, Col, Panel} from 'react-bootstrap';
import { withRouter, Switch, Route, Redirect} from 'react-router-dom';
import LoginForm from 'src/component/Login/LoginForm';
import Api from 'src/js/Api.js';
import Cognito from "src/js/Cognito.js";
import Config from 'src/config.json';
import PasswordModal from "src/js/CognitoNewPasswordModal.js"
import 'src/css/Login.css'
import Logo from "src/js/Logo.js";
import AIOILogo from "src/js/AIOILogo.js"
import LanguageChange from 'src/js/LanguageChange.js';
import SignUpForm from 'src/component/SignUp/SignUpForm';
import ForgotPassForm from 'src/component/ForgotPass/ForgotPassForm';
import ForgotPassVerification from '../ForgotPass/ForgotPassVerification';
import VerificationForm from 'src/component/SignUp/Verification';

class LoginRouter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // ID
            userId: '',
            // パスワード
            password: '',
            // 認証フラグ
            isSignIn: false,
            // 認証ローディング
            signInLoading: false,
            // 認証に失敗
            isFail: false,
            // パスワード新規登録フラグ
            isNewPasswordChallenge: false,
            // 仮登録ユーザ情報
            user: {},
            // サインアップ認証フラグ
            isSignUp: false,
            // サインアップ失敗
            isSignUpFailed: false,
            // サインアップ成功フラグ
            signUpSucceed: false,
            // サインアップローディング
            signUpLoading: false,
            // 確認失敗フラグ
            isVerificationFailed: false,
            // 認証成功フラグ
            verificationSucceed: false,
            // サインイン失敗フラグ
            signInFailed: false,
            // パスワードリセット用の確認コード送信成功フラグ
            sendResetVerificationCodeSucceed: false,
            // 確認コード送信時のローディング
            resetPassLoading: false,
            // パスワードリセット時のエラー判定
            resetIsFail: false,
            // パスワードリセット時のエラーMSG
            resetIsFailMsgIndex: "",
            // パスワードリセットの新規パスワード設定の成功フラグ
            setNewPassSucceed: false,
            // パスワード再設定の失敗判定
            setNewPassFail: false,
            // パスワード再設定の新規パスワード設定時のローディング
            setNewPassLoading: false,
            // パスワード再設定後のログイン失敗判定
            setNewPassSignInSucceed: false,
            // パスワード再設定時のエラーMSGの引数
            setNewPassErrMsgIndex: ""
        }
        // 画面最上部まで移動
        window.scrollTo(0,0);
        this.authenticateUser = this.authenticateUser.bind(this);
        this.registerNewPassword = this.registerNewPassword.bind(this);
        this.signUpUser = this.signUpUser.bind(this);
        this.signUpVerification = this.signUpVerification.bind(this);
        this.applyResetPassword = this.applyResetPassword.bind(this);
        this.setNewPassword = this.setNewPassword.bind(this);
    }
  

  // カープレートNO情報を取得
  getCarPlate(sub, cognitoUser) {

    return new Promise(function (resolve, reject) {
      let queryParams = {
        sub: sub
      };

      // APIの実行
      Api.runApi(cognitoUser, Config.API.STAGE + Config.API.CAR_PLATE_DATA_PATH, queryParams)
        .then(function onFulfilled(result) {
          resolve(result);
        })
        .catch(function onRejected(err) {
          reject(err);
        });
    });
  }

  // パスワード新規登録
  registerNewPassword(pass) {
    const sleep = (waitSeconds) => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, waitSeconds * 1000)
      })
    }

    let _this = this;

    // パスワードの新規登録
    let promise = new Promise(function (resolve, reject) {
      _this.state.user.cognitoUser.completeNewPasswordChallenge(pass, _this.state.user.userAttributes, {
        // 成功
        onSuccess: function (result) {
          console.log("成功")
          // クッキーに認証フラグを追加
          document.cookie = Config.COOKIE.AUTH_KEY_NAME + '=true; path=/; max-age=600';

          sleep(1).then(() => {
            Cognito.setCredentials(_this.state.user.cognitoUser);
            resolve(result);
          }).catch((error) => {
            console.log(error);
          });
        },
        // 失敗
        onFailure: function (err) {
          console.log(err)
          reject(err);
        }
      });
    });

    promise.then(function onFulfilled(result) {
      _this.setState({
        isNewPasswordChallenge: false,
      })

      // 成功したらSubをローカルストレージに保存
      let sub = Cognito.getCognitoUserSub();
      localStorage.setItem('sub', sub);

      // subを用いてカープレートNO情報を取得しローカルストレージに保存
      _this.getCarPlate(sub, Cognito.getCognitoUser()).then(function (result) {
        localStorage.setItem('carPlate', result.data.carPlate);
        localStorage.setItem('logCarId', result.data.logCarId);
        localStorage.setItem('downloadId', result.data.downloadId)
         // トップ画面に遷移
        _this.props.history.push("/top");
        // ユーザをセットしてルーターに反映
        _this.props.assignUser();
        alert("Registraion Successed!")
      }).catch(function (error) {

        // 認証失敗
        _this.setState({
          signInLoading: false,
          isFail: true
        });
        alert("Registraion Successed!\nBut not get carPlate")
        console.log(error);
      });
    }).catch(function onRejected(err) {
      console.log(err);
      _this.setState({
        isNewPasswordChallenge: false,
        signInLoading: false,
        isFail: true
      })
      let failedMsg = "Registration Failed...\nPassword Policy\n - Minimum length 8\n"
      alert(failedMsg);
    });
  }

  // ユーザ認証
  authenticateUser(id, pass) {

    let _this = this;

    this.setState({
      signInLoading: true,
      isFail: false,
    })

    Cognito.signIn(id, pass).then(function onFulfilled(result) {

      // 新規パスワード登録判定
      if ('userAttributes' in result) {
        _this.setState({
          isNewPasswordChallenge: true,
          user: result,
        })
        return;
      }

      // 成功したらSubをローカルストレージに保存
      let sub = Cognito.getCognitoUserSub();
      localStorage.setItem('sub', sub);

      // subを用いてカープレートNO情報を取得しローカルストレージに保存
      _this.getCarPlate(sub, Cognito.getCognitoUser()).then(function (result) {
        localStorage.setItem('carPlate', result.data.carPlate);
        localStorage.setItem('logCarId', result.data.logCarId);
        localStorage.setItem('downloadId', result.data.downloadId);
         // トップ画面に遷移
        _this.props.history.push("/top");
        // ユーザをセットしてルーターに反映
        _this.props.assignUser();

      }).catch(function (error) {

        //TODO: 以下の一時的な対処を、綺麗な処理に再設計する

        // 言語切り替え情報を一度避難
        let lng = localStorage.getItem('lng')

        // クッキーを有効期限切れにすることで、ログイン情報を削除
        let date = new Date();
        date.setTime(date.getTime() - 1);
        document.cookie = Config.COOKIE.AUTH_KEY_NAME + '=; expires=' + date.toUTCString();
        localStorage.clear();

        // 言語切り替え情報が消えてしまっているので、再セット
        localStorage.setItem('lng',lng)

        // 認証失敗
        _this.setState({
          signInLoading: false,
          isFail: true
        });
        console.log(error);
      });

    }).catch(function onRejected(error) {

      // 認証失敗
      _this.setState({
        signInLoading: false,
        isFail: true
      })
      console.log(error);
    });
  }

  // ユーザのサインアップ処理
  signUpUser(userName, email, password){
    let _this = this;

    this.setState({
      signUpLoading: true,
      isSignUpFailed: false,
      signUpSucceed: false
    })

    Cognito.signUp(userName, email, password)
    .then(function onFulfilled(result){
      console.log("Success!")
      // resolve(result);
      _this.setState({
        signUpLoading: true,
        isSignUpFailed: false,
        signUpSucceed: true
      })
    }).catch(function onRejected(error){
      // 認証失敗
      _this.setState({
        signUpLoading :false,
        isSignUpFailed: true,
        signUpSucceed: false
      })
      console.log(error);
    })
  }


  // ユーザのサインアップ認証処理. 認証処理が完了したらtop画面にも遷移するようにする。
  signUpVerification(userName, verificationCode, pass){

    this.setState({
      VerificationLoading: true,
      isVerificationFailed: false,
      verificationSucceed: false,
      signInFailed: false
    })
    
    let _this = this;
    //　認証に成功した場合、認証情報を取得して、ログインする。
    Cognito.signUpVerification(userName, verificationCode).then(function onFulfilled(){
      console.log("Success Verification!")
      Cognito.signIn(userName, pass).then(function onFulfilled(result) {
  
        // 成功したらSubをローカルストレージに保存
        let sub = Cognito.getCognitoUserSub();
        localStorage.setItem('sub', sub);
  
        // subを用いてカープレートNO情報を取得しローカルストレージに保存
        _this.getCarPlate(sub, Cognito.getCognitoUser()).then(function (result) {
          localStorage.setItem('carPlate', result.data.carPlate);
          localStorage.setItem('logCarId', result.data.logCarId);
          localStorage.setItem('downloadId', result.data.downloadId);
            // トップ画面に遷移
          _this.props.history.push("/top");
          // ユーザをセットしてルーターに反映
          _this.props.assignUser();
          _this.setState({
            VerificationLoading: true,
            isVerificationFailed: false,
            verificationSucceed: true,
            signInFailed: false
          })
          alert(
            "User Verification Completed!\nEnjoy your journey!"
            )

        }).catch(function (error) {
          // 認証失敗
          _this.setState({
            VerificationLoading: false,
            isVerificationFailed: true,
            verificationSucceed: false,
            signInFailed: true
          })
          console.log(error);
        });
  
      }).catch(function onRejected(error) {
        // 認証失敗
        _this.setState({
          VerificationLoading: false,
          isVerificationFailed: true,
          verificationSucceed: false,
          signInFailed: true
        })
        console.log(error);
      });
    }).catch(function onRejected(error){
      // 認証失敗
      _this.setState({
        VerificationLoading: false,
        isVerificationFailed: true,
        verificationSucceed: false
      })
      console.log(error);
    })
  }

  // パスワードリセットに必要な確認コードの送信をリクエストする
  applyResetPassword(userName){
    
    // ローディングの開始
    this.setState({
      resetPassLoading: true
    })
    let _this = this;

    if(userName == ""){
      // ユーザ名未入力時、エラーメッセージ
      console.log("[Error] VinNo is empty");
      _this.setState({
        resetPassLoading: false,
        resetIsFail: true,
        resetIsFailMsgIndex: "msg_reset_pass_04"
      });
      return;
    }    

    Cognito.resetPassword(userName).then(function onFulfilled(result){

      // 確認コード送信の成功を通知
      _this.setState({
        sendResetVerificationCodeSucceed: true,
        resetPassLoading: false
      });
      console.log("Succeed New Password Setting")
      
    }).catch(function(err){
      
      if (err.code == "UserLambdaValidationException"){
        //
        // UserLambdaValidationException用のエラーチェック
        //
        switch(err.message){
          case "CustomMessage failed with error The specified VinNo does not exist.":
            _this.setState({
              resetIsFailMsgIndex: "msg_reset_pass_05"
            })
            break;
          default:
            _this.setState({
              resetIsFailMsgIndex: "msg_reset_pass_03"
            })
            break;
        }
      }else{
        //
        // Cognitoから返ってきたエラー用のチェック
        //
        switch(err.code){
          case "LimitExceededException":
            // 試行回数が多い場合のエラー
            _this.setState({
              resetIsFailMsgIndex: "msg_reset_pass_01"
            })
            break;
          case "UserNotFoundException":
            _this.setState({
              resetIsFailMsgIndex: "msg_reset_pass_02"
            })
            break;
          default:
            _this.setState({
              resetIsFailMsgIndex: "msg_reset_pass_03"
            })
            break;
        }
      }

      _this.setState({
        resetPassLoading: false,
        resetIsFail: true,
      })
      
    })

  }

  // パスワードリセット後の新規パスワード設定、その後Topページに移動する
  setNewPassword(userName, newPassword, verificationCode){
    let _this = this;

    // ローディングの開始
    this.setState({
      setNewPassLoading: true
    })

    Cognito.confirmResetPassword(userName, newPassword, verificationCode)
      .then(function onFulfilled(result){

        // パスワード設定の成功を通知
        _this.setState({
          setNewPassSucceed: true
        })

        Cognito.signIn(userName, newPassword).then(function onFulfilled(result) {
  
          // 成功したらSubをローカルストレージに保存
          let sub = Cognito.getCognitoUserSub();
          localStorage.setItem('sub', sub);
    
          // subを用いてカープレートNO情報を取得しローカルストレージに保存
          _this.getCarPlate(sub, Cognito.getCognitoUser()).then(function (result) {
            
            localStorage.setItem('carPlate', result.data.carPlate);
            localStorage.setItem('logCarId', result.data.logCarId);
            localStorage.setItem('downloadId', result.data.downloadId);
            
            alert(
              "You have successfully reset your password and logged in."
            )

            // Top画面に遷移
            _this.props.history.push("/top");

            // ユーザをセットしてルーターに反映
            _this.props.assignUser();
  
          }).catch(function (error) {
            
            console.log(error);

            // 失敗
            _this.setState({
              setNewPassFail: true,
              setNewPassLoading: false,
              setNewPassErrMsgIndex: "msg_set_new_pass_04"
            })
          });
    
        }).catch(function onRejected(error) {
          console.log(error);

          // ログインの失敗
          _this.setState({
            setNewPassFail: true,
            setNewPassLoading: false,
            setNewPassErrMsgIndex: "msg_set_new_pass_04"
          })
        });

      })
      .catch(function(err){
        // 承認失敗時の処理
        console.log(err)
        switch(err.code){
          case "CodeMismatchException":
          case "ExpiredCodeException":
            _this.setState({
              setNewPassErrMsgIndex:"msg_set_new_pass_01",
            });
            break;
          case "LimitExceededException":
            _this.setState({
              setNewPassErrMsgIndex:"msg_limit_exceeded",
            });
            break;
          case "InvalidPasswordException":
            _this.setState({
              setNewPassErrMsgIndex:"msg_set_new_pass_02",
            });
            break;
          default:
            _this.setState({
              setNewPassErrMsgIndex:"msg_set_new_pass_03",
            });
            break;
        }

        _this.setState({
          setNewPassFail: true,
          setNewPassLoading: false,
        });
      });
  }

  render() {

    return (
      <div className='mainContents'>
        {
          // ローディング判定
          this.state.isNewPasswordChallenge ?
            <PasswordModal registerNewPassword={this.registerNewPassword} /> :
            false
        }
          <Row>
            <div className="mini-div" />
            <Col md={12} sm={12} xs={12}>
              <LanguageChange />
              <Panel className="loginFormPanel center-block" >
                <Col className="logos">
                  <Logo />
                  <AIOILogo />
                </Col>
                <Switch>
                  <Route exact path="/">
                    <LoginForm authenticate={this.authenticateUser} isFail={this.state.isFail} signInLoading={this.state.signInLoading} />
                  </Route>
                  <Route exact path="/login">
                    <LoginForm authenticate={this.authenticateUser} isFail={this.state.isFail} signInLoading={this.state.signInLoading} />
                  </Route>
                  <Route exact path="/signup">
                    <SignUpForm signUp={this.signUpUser} isSignUpFailed={this.state.isSignUpFailed} signUpLoading={this.state.signUpLoading} signUpSucceed={this.state.signUpSucceed}/>
                  </Route>
                  <Route exact path="/forgotpass">
                    <ForgotPassForm resetPass={this.applyResetPassword} resetIsFail={this.state.resetIsFail} 
                    resetIsFailMsgIndex={this.state.resetIsFailMsgIndex} 
                    verificationCodeSucceed={this.state.sendResetVerificationCodeSucceed} resetPassLoading={this.state.resetPassLoading}/>
                  </Route>
                  <Route exact path= "/forgotpass-verification">
                    <ForgotPassVerification setNewPassword={this.setNewPassword} authenticate={this.authenticateUser} 
                        setNewPassLoading={this.state.setNewPassLoading} setNewPassSucceed={this.state.setNewPassSucceed} 
                        setNewPassFail={this.state.setNewPassFail}
                        codeMismatchException={this.state.codeMismatchException}
                        errMsgIndex={this.state.setNewPassErrMsgIndex}
                    />
                  </Route>
                  <Route exact path="/verification">
                    <VerificationForm Verification={this.signUpVerification} isVerificationFailed={this.state.isVerificationFailed} 
                      VerificationLoading={this.state.VerificationLoading} verificationSucceed={this.state.verificationSucceed} signInFailed={this.state.signInFailed}/>
                  </Route>
                  <Route path="*">
                      <Redirect to="/login" />
                  </Route>
                </Switch>
              </Panel>
            </Col>
          </Row>
      </div>
    );
  }
}

export default withRouter(LoginRouter);



// WEBPACK FOOTER //
// ./src/component/Router/LoginRouter.js